import { createSlice } from '@reduxjs/toolkit'
import { AppSecretKeySchema } from '../types/ApplicationSecretKeySchema'
import { addNewApplication } from '../../../../features/AddNewApplication'
import { resetAppSecretKey } from '../../../../features/ResetAppSecret'

const initialState: AppSecretKeySchema = {
	applicationId: undefined,
	secret: undefined
}

const applicationSecretKeySlice = createSlice({
	name: 'applicationSecretKey',
	initialState,
	reducers: {
		setAppKeyAndID: (state, action) => {
			state.applicationId = action.payload.applicationId
			state.secret = action.payload.secret
		},
		resetAppKeyAndID: (state) => {
			state.applicationId = undefined
			state.secret = undefined
		}
	},
	extraReducers: (builder) => {
		builder
			.addCase(addNewApplication.fulfilled, (state, action) => {
				state.applicationId = action.payload.applicationId
				state.secret = action.payload.secret
			})
			.addCase(resetAppSecretKey.fulfilled, (state, action) => {
				state.applicationId = action.payload.applicationId
				state.secret = action.payload.secret
			})
	}
})

export const { actions: appSecretKeyActions } = applicationSecretKeySlice
export const { reducer: appSecretKeyReducer } = applicationSecretKeySlice
